// @mui
import { useTheme } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
// theme
import { bgBlur } from 'src/theme/css';
// hooks
import { useResponsive } from 'src/hooks/use-responsive';
// components
import SvgColor from 'src/components/svg-color';
import { useSettingsContext } from 'src/components/settings';
//
import { Button, Menu, MenuItem } from '@mui/material';
import { Colors } from 'src/theme/palette';
import { useAuthContext } from 'src/auth/hooks';
import React from 'react';
import { enqueueSnackbar } from 'notistack';
import { useRouter } from 'src/routes/hooks';
import { HEADER, NAV } from '../config-layout';
import {
  AccountPopover,
} from '../_common';

// ----------------------------------------------------------------------

type Props = {
  onOpenNav?: VoidFunction;
  iftaOnly?: boolean;
  openNav?: boolean;
  accountArea?: React.ReactNode;
};

export default function Header({ onOpenNav, openNav = false, iftaOnly = false, accountArea }: Props) {
  const theme = useTheme();

  const settings = useSettingsContext();
  const router = useRouter();

  const isNavHorizontal = settings.themeLayout === 'horizontal';

  const lgUp = useResponsive('up', 'lg');
  const { session, changeOrganization } = useAuthContext();
  const user = session?.user;

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const _changeOrganization = (organizationId: number) => {
    setAnchorEl(null);
    changeOrganization(organizationId).then(() => {
      router.reload();
    }).catch(e => {
      enqueueSnackbar("An unexpected error has occured", {variant: "error"});
      router.reload();
    })

  };


  const renderContent = (
    <>
      {/* {isNavHorizontal && <Logo sx={{ mr: 2.5, ml: -3 }} />} */}

      {!isNavHorizontal && (
        <IconButton onClick={onOpenNav} sx={{marginLeft: lgUp ? "-42px" : "0px"}}>
          <SvgColor src="/assets/icons/navbar/ic_menu_item.svg" color={Colors.greyText} />
        </IconButton>
      )}

      {/* {!iftaOnly && <Searchbar />} */}

      <Stack
        flexGrow={1}
        direction="row"
        alignItems="center"
        justifyContent="flex-end"
        spacing={{ xs: 0.5, sm: 1 }}
      >
        {(user?.organizationIds?.length || 0) > 1 && <>

          <Button sx={{color: Colors.greyText}} onClick={(e) => setAnchorEl(e.currentTarget)}>
            {session?.organization?.organizationName}
          </Button>
          <Menu
            anchorEl={anchorEl}
            open={anchorEl != null}
            onClose={() => setAnchorEl(null)}
            MenuListProps={{
              'aria-labelledby': 'basic-button',
            }}
          >
            {user && user.organizationIds.map((organizationId, index) => <MenuItem onClick={() => _changeOrganization(organizationId)} key={organizationId}>{user.organizationNames[index]}</MenuItem>)}

          </Menu>
        </>}
        {/* <NotificationsPopover /> */}

        {/* <SettingsButton /> */}

        {accountArea ?? <AccountPopover />}
      </Stack>
    </>
  );

  let topHeight = HEADER[settings.themeLayout].H_MOBILE;
  if (lgUp) {
    topHeight = HEADER[settings.themeLayout].H_DESKTOP;
    if (isNavHorizontal) {
      topHeight = HEADER[settings.themeLayout].H_DESKTOP_OFFSET;
    }
  }

  return (
    <AppBar
      sx={{
        height: topHeight,
        zIndex: theme.zIndex.appBar + 1,
        ...bgBlur({
          color: theme.palette.background.default,
        }),
        ...(lgUp && {
          width: openNav ? `calc(100% - ${NAV.W_VERTICAL}px)` : `calc(100% - ${NAV.W_VERTICAL_NOT_OPEN}px)`,
          ...(isNavHorizontal && {
            width: 1,
            bgcolor: 'background.default',
            borderBottom: `dashed 1px ${theme.palette.divider}`,
          }),
        }),
      }}
    >
      <Toolbar
        sx={{
          height: 1,
          px: { lg: 5 },
          position: "relative"
        }}
      >
        {renderContent}
      </Toolbar>
    </AppBar>
  );
}
